import {doc} from '../docs.js';
import {mod} from "utils/mod.js"
import {getGeometry, diameter, centroid} from "effects/midi/mappable/lang/geometry.js";
import {isNumber} from 'utils/IsNumber.js';
import Delaunator from 'delaunator';


doc(
    "delaunay",
    {},
    "computes delaunay triangulation for pts",
    undefined,
    {
        tags: "Graphics",
    }
);

export const delaunay = (object) => {
    let del;
    return ([pts]) => {
        if (!pts) {
            return undefined;
        }

        if (!Array.isArray(pts) || pts.some(x => !isNumber(x))) {
            return ;
        }

        if (!del) {
            pts.forEach((pt, i) => del.coords[i] = pt);
            del.update();
        } else {
            del = new Delaunator(pts);
        }

        let coords = [];
        for (let i=0; i < del.triangles.length; i+=3) {
            let tris = [
                del.triangles[i],
                del.triangles[i+1],
                del.triangles[i+2]];
            coords.push(pts[2*tris[0]]);
            coords.push(pts[2*tris[0]+1]);
            coords.push(pts[2*tris[1]]);
            coords.push(pts[2*tris[1]+1]);
            coords.push(pts[2*tris[2]]);
            coords.push(pts[2*tris[2]+1]);
        }
        return [coords];
    };
};

doc(
    "delaunayIndex",
    {},
    "computes delaunay triangulation for pts index",
    undefined,
    {
        tags: "Graphics",
    });

export const delaunayIndex = (object) => {
    let del;
    return ([pts]) => {
        if (!pts) {
            return undefined;
        }

        if (!pts || (!ArrayBuffer.isView(pts) && (!Array.isArray(pts) || pts.some(x => !isNumber(x))))) {
            return ;
        }
        if (del) {
            pts.forEach((pt, i) => del.coords[i] = pt);
            del.update();
        } else {
            del = new Delaunator(pts);
        }
        return [del.triangles];
    };
};
